import AddAssetProps, { AddSectorProps, AddAssetTaranProps, AssetCommonProps } from '../interfaces/AddAssetProps';

export const DEFAULT_ASSET: AddAssetProps = {
  tracking_id: '',
  gnodeb_id: '',
  site_id: '',
  cbrs_node_name: '',
  description: '',
  latitude: 0,
  longitude: 0,
  serial_number: '',
  device_mac: '',
  device_pn: '',
  cm_serial_number: '',
  cm_mac: '',
  cm_pn: '',
  region: '',
  status: 'Field Tech',
  images: [],
  vendor_id: 0,
  mounting_type: '',
  height: 0,
  sectors: [],
  venue_id: null,
  building_id: null,
  floor_id: null,
  deployment_location: 'outdoor',
  technology_type: 'cbrs_5g',
  band_id: '',
};

export const DEFAULT_SECTOR: AddSectorProps = {
  sector_id: '',
  tracking_id: '',
  status: 'Field Tech',
  height: 0,
  height_type: 'HEIGHT_TYPE_AGL',
  horizontal_accuracy: '',
  vertical_accuracy: '',
  haat: '0',
  azimuth: 0,
  downtilt: '0',
  azimuth_image: '',
  downtilt_image: '',
  height_image: '',
  measurement_capability: 'MSRMT_WITHOUT_GRANT',
  deployment_type: 'outdoor',
  call_sign: '1',
  grouping_params: '1',
  supported_spec: '',
};

export const DEFAULT_ASSET_TARANA: AddAssetTaranProps = {
  tracking_id: '',
  gnodeb_id: '',
  site_id: '',
  cbrs_node_name: '',
  description: '',
  latitude: 0,
  longitude: 0,
  serial_number: [],
  device_mac: '',
  device_pn: '',
  cm_serial_number: '',
  cm_mac: '',
  cm_pn: '',
  region: '',
  status: 'Field Tech',
  images: [],
  vendor_id: 0,
  mounting_type: '',
  height: 0,
  sectors: [],
  venue_id: null,
  building_id: null,
  floor_id: null,
  deployment_location: 'outdoor',
  technology_type: 'cbrs_5g',
  band_id: '',
};

export const DEFAULT_ASSET_COMMON: AssetCommonProps = {
  tracking_id: '',
  site_id: '',
  description: '',
  cbrs_node_name: '',
  latitude: 0,
  longitude: 0,
  serial_number: [],
  device_mac: '',
  device_pn: '',
  region: '',
  status: 'Field Tech',
  cm_mac: '',
  cm_serial_number: '',
  cm_pn: '',
  gnodeb_id: '',
  vendor_id: 0,
  mounting_type: '',
  height: 0,
  technology_type: 'cbrs_5g',
  venue_id: null,
  building_id: null,
  floor_id: null,
  deployment_location: 'outdoor',
  venue_name: null,
  building_name: null,
  floor_number: null,
  address: null,
  directionality: 'Omni',
  state_machine: [
    {
      reg_pending: false,
      usm_creation: false,
      grant_aquired: false,
      registered: false,
      authorized: false,
      on_air: false,
    },
  ],
  images: [],
  vendor_type: '',
  job_type: null,
  band_id: null,
  band_name: null,
  band_type: null,
  cbrs_support: null,
  afc_support: null,
  apartment: '',
  room_name: '',
};
